// Mapp Addresses to compare Google API and our db
const countryNameMapper = {
  //   USA
  'united states': ['united states of america (the)', 'usa', 'us', 'america'],
  usa: ['united states of america (the)', 'united states', 'us', 'america'],
  us: ['united states of america (the)', 'united states', 'usa', 'america'],

  // UK
  'united kingdom': ['united kingdom of great britain and northern ireland (the)', 'uk', 'great britain', 'britain'],
  uk: ['united kingdom of great britain and northern ireland (the)', 'united kingdom', 'great britain'],
  'great britain': ['united kingdom of great britain and northern ireland (the)', 'united kingdom', 'uk'],

  // Other countries
  'south korea': ['korea (the republic of)', 'republic of korea'],
  'north korea': ["korea (the democratic people's republic of)", "democratic people's republic of korea"],
  iran: ['iran (islamic republic of)', 'islamic republic of iran'],
  venezuela: ['venezuela (bolivarian republic of)', 'bolivarian republic of venezuela'],
  bolivia: ['bolivia (plurinational state of)', 'plurinational state of bolivia'],
  netherlands: ['netherlands (the)', 'holland'],
  philippines: ['philippines (the)'],
  bahamas: ['bahamas (the)'],
  gambia: ['gambia (the)'],
  'czech republic': ['czechia', 'czech republic (the)'],
  macedonia: ['north macedonia', 'macedonia (the former yugoslav republic of)'],
};

const findCountryByFuzzyMatch = (googleCountryName, countries) => {
  const searchName = googleCountryName.toLowerCase().trim();

  // 1. Try to find exact match
  let match = countries.find(c => c.name?.toLowerCase() === searchName);
  if (match) return match;

  // 2. Search with mapper
  const mappedNames = countryNameMapper[searchName] || [];
  for (const mappedName of mappedNames) {
    match = countries.find(c => c.name?.toLowerCase() === mappedName.toLowerCase());
    if (match) return match;
  }

  // 3. Search by the partly match (include)
  match = countries.find(c => {
    const countryName = c.name?.toLowerCase();
    return countryName?.includes(searchName) || searchName.includes(countryName);
  });
  if (match) return match;

  // 4. Search by sepparate worlds
  const searchWords = searchName.split(' ').filter(word => word.length > 2);
  if (searchWords.length > 0) {
    match = countries.find(c => {
      const countryWords =
        c.name
          ?.toLowerCase()
          .split(' ')
          .filter(word => word.length > 2) || [];
      const commonWords = searchWords.filter(word =>
        countryWords.some(countryWord => countryWord.includes(word) || word.includes(countryWord)),
      );
      return commonWords.length >= Math.min(searchWords.length, 3);
    });
    if (match) return match;
  }

  match = countries.find(c => {
    const countryName = c.name?.toLowerCase();
    return countryName?.startsWith(searchName) || searchName.startsWith(countryName?.split(' ')[0]);
  });

  return match;
};

const levenshteinDistance = (str1, str2) => {
  const matrix = [];
  for (let i = 0; i <= str2.length; i++) {
    matrix[i] = [i];
  }
  for (let j = 0; j <= str1.length; j++) {
    matrix[0][j] = j;
  }
  for (let i = 1; i <= str2.length; i++) {
    for (let j = 1; j <= str1.length; j++) {
      if (str2.charAt(i - 1) === str1.charAt(j - 1)) {
        matrix[i][j] = matrix[i - 1][j - 1];
      } else {
        matrix[i][j] = Math.min(matrix[i - 1][j - 1] + 1, matrix[i][j - 1] + 1, matrix[i - 1][j] + 1);
      }
    }
  }
  return matrix[str2.length][str1.length];
};

export const parseAddressToCompanyValues = function(address, countries = []) {
  let countryId = null;

  if (address?.country && countries.length > 0) {
    // Try Find with mapper
    const foundCountry = findCountryByFuzzyMatch(address.country, countries);
    countryId = foundCountry?.id;

    // If no try to find with Levenshtein distance
    if (!countryId) {
      const searchName = address.country.toLowerCase().trim();
      let bestMatch = null;
      let minDistance = Infinity;

      countries.forEach(country => {
        if (!country.name) return;

        const distance = levenshteinDistance(searchName, country.name.toLowerCase());
        const threshold = Math.max(3, Math.floor(country.name.length * 0.3));

        if (distance < threshold && distance < minDistance) {
          minDistance = distance;
          bestMatch = country;
        }
      });

      if (bestMatch) {
        countryId = bestMatch.id;
      } else {
        console.warn(`Country not found: "${address.country}"`);
      }
    }
  }

  let companyAddress = {
    name: address?.name,
    addressLine1:
      address?.street || address?.streetnumber ? `${address?.street || ''} ${address?.streetnumber || ''}`.trim() : '',
    postcode: address?.postalcode,
    city: address?.city,
    website: address?.website,
    phone_number: address?.phonenumber,
    lat: address?.lat,
    lng: address?.lng,
  };

  if (countryId) {
    companyAddress.countryId = countryId;
  }

  return companyAddress;
};
